import { FormBlock } from "@/components/FormBuilder/types";
import { endorsementsForm } from "@/forms/admin/endorsements";
import Vue from "vue";
import {
  endorsementMapState,
  endorsementMapMutations
} from "@/store/modules/endorsements";
import {
  companyLineOfBusiness,
  FormsByPolicyType
} from "@/helpers/selectOptions";
import { SET_EDIT_FIELD, SET_ITEM } from "@/store/mutation-types";
import { IEndorsement } from "@/store/modules/endorsements/types";

interface IData {
  errorMessage: string;
  successMessage: string;
  initialized: boolean;
  resourceNotFound: boolean;
  resourceNotFoundMsg: string;
  loadingText: string;
  validationData: Record<string, any>;
  loading: boolean;
}
export default Vue.extend({
  data(): IData {
    return {
      errorMessage: "",
      successMessage: "",
      validationData: {},
      loadingText: "Submitting new endorsement data. Please wait...",
      initialized: false,
      resourceNotFound: false,
      resourceNotFoundMsg:
        "Ooops! The endorsement you are looking for cannot be found.",
      loading: false
    };
  },
  computed: {
    ...endorsementMapState(["editing", "makingApiRequest", "allEndorsements"]),
    formFields(): FormBlock[] {
      return endorsementsForm;
    },
    companyOptions(): { label: string; value: string }[] {
      const initData = this.$store.state.auth["initData"];
      const { companies = [] } = initData;
      return companies.map((company: any) => ({
        label: company.companyName,
        value: company.companyNumber
      }));
    },
    formTypesOptions(): { label: string; value: string }[] {
      return FormsByPolicyType;
    },
    appliesToOptions(): { label: string; value: string }[] {
      return companyLineOfBusiness.map((option: any) => ({
        label: option.label,
        value: option.value
      }));
    },
    endorsementId(): string {
      return this.$route.params.endorsementId;
    },
    formIsValid(): boolean {
      return Boolean(this.validationData.formIsValid);
    }
  },
  methods: {
    ...endorsementMapMutations({ editField: SET_EDIT_FIELD }),
    ...endorsementMapMutations(["SET_EDIT"]),
    ...endorsementMapMutations({ setItem: SET_ITEM }),

    async cancelCallback(): Promise<any> {
      this.$router.push("/admin/endorsements").catch(() => {});
    },
    formFieldChangedHandler({
      key,
      value
    }: {
      key: keyof IEndorsement;
      value: string;
    }) {
      this.editField({ key, value });
    }
  },
  destroyed() {
    this.SET_EDIT({} as IEndorsement);
  }
});
